import React from 'react';
import cl from 'classnames';
import { history } from 'umi';
import { HexToRGB, appUrlJump } from '@/utils/utils';
import { sanitizeParam, sanitizeUrl } from '@/utils/sanitize';
import Clickable from '@/components/Clickable';
import styles from './index.less';

export default function SinglePost({
  visible,
  showTitle,
  title,
  showMore,
  moreName,
  moreLink,
  titleIconPosition = 'L',
  titleIcon = [
    {
      src: '',
      width: 0,
      height: 0,
      iconName: '',
      linkType: '',
      link: '',
      linkId: '',
    },
  ],
  pictures,
  titleFontSize,
  titleFontColor,
  titleFontColorOpacity,
  isTitleFontBold,
  isTitleFontItalic,
  isTitleBg,
  titleBgColor,
  titleBgColorOpacity,
  staticTitleFontSize,
  staticTitleFontColor,
  staticTitleFontColorOpacity,
  isStaticTitleFontBold,
  isStaticTitleFontItalic,
  hasBg,
  bgType,
  bgColor,
  bgColorOpacity,
  bgImg,
  topMargin,
  bottomMargin,
  horizontalOutterMargin,
  topPadding,
  bottomPadding,
  horizontalInnerPadding,
  objFocus,
}) {
  //   const localState = localStorage.getItem('currState');
  //   const settingState = localStorage.getItem('settingModal');
  //   const prevState = localStorage.getItem('currPrevState');
  const titleStyles = {
    fontSize: `${titleFontSize}px`,
    color: HexToRGB(titleFontColor, titleFontColorOpacity),
    fontWeight: isTitleFontBold === 'Y' ? 'bold' : 'normal',
    // fontFamily: isTitleFontBold === 'Y' ? 'NunitoSans-Bold' : 'NunitoSans-Regular',
    fontFamily: 'Roboto',
    fontStyle: isTitleFontItalic === 'Y' ? 'italic' : 'normal',
    border: objFocus?.titleFocus === 'Y' ? '2px dashed #e0e0e0' : '2px solid transparent',
    display: !showTitle ? 'none' : '',
  };

  const moreStyles = {
    fontSize: `${staticTitleFontSize}px`,
    color: HexToRGB(staticTitleFontColor, staticTitleFontColorOpacity),
    fontWeight: isStaticTitleFontBold === 'Y' ? 'bold' : 'normal',
    // fontFamily: isStaticTitleFontBold === 'Y' ? 'NunitoSans-Bold' : 'NunitoSans-Regular',
    fontFamily: 'Roboto',
    fontStyle: isStaticTitleFontItalic === 'Y' ? 'italic' : 'normal',
    border: objFocus?.staticFocus === 'Y' ? '2px dashed #e0e0e0' : '2px solid transparent',
    display: !showMore || !showTitle ? 'none' : '',
  };

  const titleBgStyle = {
    background: HexToRGB(titleBgColor, titleBgColorOpacity),
  };

  const bgStyle = {
    marginTop: `${topMargin}px`,
    marginBottom: `${bottomMargin}px`,
    marginLeft: `${Number(horizontalOutterMargin || 0) - 12}px`,
    marginRight: `${Number(horizontalOutterMargin || 0) - 12}px`,
    backgroundColor:
      hasBg === 'Y' && bgType === 'Color' ? HexToRGB(bgColor, bgColorOpacity) : 'transparent',
    backgroundImage: hasBg === 'Y' && bgType === 'Image' ? `url(${bgImg.src})` : 'initial',
    backgroundSize: '100%',
    backgroundPosition: 'top center',
    backgroundRepeat: 'no-repeat',
  };

  const innerStyle = {
    paddingTop: `${topPadding}px`,
    paddingBottom: `${bottomPadding}px`,
    paddingLeft: `${horizontalInnerPadding}px`,
    paddingRight: `${horizontalInnerPadding}px`,
  };

  // 点击事件
  const onClickHandler = item => {
    const initAppStr = window.localStorage.getItem('initApp');
    const initApp = JSON.parse(initAppStr) || {};
    const { link } = item;
    // 如果link不存在，结束方法
    if (!link) {
      return;
    }
    // 是app原生页面
    if (item?.linkType === '1') {
      appUrlJump(item?.link, true);
      return;
    }
    if (item?.link?.includes('http')) {
      // window.open(link, '_self');
      // appUrlJump(item?.link);
      if (window?.clp || window?.dito) {
        appUrlJump(link);
      } else {
        const rawQuery = history.location.query || {};
        const token = sanitizeParam(rawQuery.token, /^[a-zA-Z0-9._-]*$/) || initApp?.token || '';
        const currentAccNbr =
          sanitizeParam(rawQuery.currentAccNbr, /^[0-9]*$/) || initApp?.phone || '';
        const prefix = sanitizeParam(rawQuery.prefix, /^[0-9]*$/) || initApp?.prefix || '';
        // return;
        const safeUrl = sanitizeUrl(
          `${link}${
            link?.includes('?') ? '&' : '?'
          }token=${token}&currentAccNbr=${currentAccNbr}&prefix=${prefix}`,
        );
        if (safeUrl) {
          window.location.href = safeUrl;
        }
      }
    } else {
      history.push(item?.link);
    }
  };

  return (
    <div
      className={cl(
        styles.carouselBox,
        // localState === '0' || prevState === 'Y' || settingState === 'Y' ? styles.previewBox : null,
        {
          hidden: !visible,
        },
      )}
      style={bgStyle}
    >
      <div className={styles.inner} />
      <div style={innerStyle}>
        <div className={styles.carouselBoxHeader} style={isTitleBg === 'Y' ? titleBgStyle : {}}>
          {titleIconPosition === 'L' ? (
            <div className={cl(styles.moreTitle, { hidden: !showTitle })} style={titleStyles}>
              {titleIcon[0]?.src?.includes('http') && (
                <img style={{ width: '24px', marginRight: '4px' }} alt="" src={titleIcon[0]?.src} />
              )}
              {title}
            </div>
          ) : (
            <div className={cl(styles.moreTitle, { hidden: !showTitle })} style={titleStyles}>
              {title}
              {titleIcon[0]?.src?.includes('http') && (
                <img style={{ width: '24px', marginLeft: '4px' }} alt="" src={titleIcon[0]?.src} />
              )}
            </div>
          )}
          <a
            href={moreLink}
            className={cl(styles.titleMore, { hidden: !showMore || !showTitle })}
            style={moreStyles}
          >
            {moreName}
          </a>
        </div>
        <div className={styles.imgBox}>
          {(pictures || []).map((item, index) => (
            <Clickable
              as="img"
              src={`${item.src}?_=${Date.now()}`}
              alt=""
              key={index}
              style={{ width: '100%' }}
              onClick={() => onClickHandler(item)}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
